import { useState } from 'react';

const FAQAllInclusive = () => {
  const faqs = [
    {
      question: "What exactly does 'all-inclusive' mean?",
      answer: "Great question! 'All-inclusive' means that the price of your holiday covers pretty much everything: your flights, your hotel room, all your meals and snacks (yes, even those midnight cravings!), unlimited drinks (alcoholic and non-alcoholic), and usually a whole bunch of activities and entertainment. It's like stepping into a world where you can truly relax and indulge without constantly reaching for your wallet."
    },
    {
      question: "Are all-inclusive holidays good for families?",
      answer: "Absolutely! All-inclusive resorts are a fantastic option for families. Many have dedicated kids' clubs with supervised activities, water parks, playgrounds, and even babysitting services. This means parents can enjoy some well-deserved relaxation while the kids are having a blast. Plus, with all the food and drinks included, you won't have to worry about picky eaters or those endless snack requests!"
    },
    {
      question: "What kind of activities can I expect at an all-inclusive resort?",
      answer: "It depends on the resort, but most offer a wide range of activities, both on land and in the water. Think snorkeling, kayaking, sailing, beach volleyball, tennis, fitness classes, dance lessons, and even cooking demonstrations. Some resorts also have nightly entertainment like live music, shows, and themed parties."
    },
    {
      question: "Are there any hidden costs with all-inclusive holidays?",
      answer: "Generally, no! That's the beauty of all-inclusive. However, some resorts might have premium restaurants or activities that require an extra fee. It's always a good idea to check the fine print before you book to avoid any surprises."
    },
    {
      question: "Where can I find the best all-inclusive holiday deals?",
      answer: "Right here at Halo Holidays, of course! We've scoured the globe to find the most amazing all-inclusive resorts and negotiated the best deals, so you can experience paradise without breaking the bank. Whether you're dreaming of the Caribbean, Mexico, the Maldives, or beyond, we've got you covered."
    }
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mt-8 px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 lg:w-[900px]">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQAllInclusive;
